module.exports = __webpack_public_path__ + "img/marketSend.dcf69382.svg";